/* eslint-disable max-len */
import { FC } from 'react';

import { colors } from '../../constants/colors';

type BackSvgProps = {
  onClick?: () => void;
};

export const BackSvg: FC<BackSvgProps> = ({ onClick }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'pointer' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={colors.blue}
        d="M21.5605 23.9395L19.4392 26.0608L9.37857 16.0001L19.4392 5.93945L21.5605 8.06077L13.6212 16.0001L21.5605 23.9395Z"
      />
    </svg>
  );
};
